import { render, staticRenderFns } from "./ViewFilePage.vue?vue&type=template&id=3445bba6&scoped=true"
import script from "./ViewFilePage.vue?vue&type=script&lang=js"
export * from "./ViewFilePage.vue?vue&type=script&lang=js"
import style0 from "./ViewFilePage.vue?vue&type=style&index=0&id=3445bba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445bba6",
  null
  
)

export default component.exports